import React, { useState } from 'react';

function MemorialMenu({ sections = [], onItemSelect }) {
  const [activeId, setActiveId] = useState(null);

  const toggle = (id) => setActiveId((prev) => (prev === id ? null : id));

  return (
    <div>
      {/* Home button (back to Memorials) */}
      <div className='mb-3'>
        <button
          type='button'
          className='d-flex align-items-center text-body text-decoration-none bg-transparent border-0 w-100'
          onClick={() =>
            onItemSelect &&
            onItemSelect({
              id: 'welcome',
              link: 'welcome',
              label: 'Memorial Home',
            })
          }
        >
          <i className='mdi mdi-dog font-size-20 text-primary me-2' />
          <span>Memorial Home</span>
        </button>
      </div>

      {/* Dynamic sections */}
      {(sections || []).map((parent) => (
        <div key={parent.id} className='mb-3'>
          <button
            type='button'
            className='d-flex align-items-center text-body text-decoration-none bg-transparent border-0 w-100'
            data-bs-toggle='collapse'
            data-bs-target={`#mem-collapse-${parent.id}`}
            aria-expanded={activeId === parent.id}
            aria-controls={`mem-collapse-${parent.id}`}
            onClick={() => toggle(parent.id)}
          >
            <i
              className={`mdi ${
                activeId === parent.id ? 'mdi-folder-open' : 'mdi-folder'
              } font-size-20 text-warning me-2`}
            />
            {parent.name}
            <i className='mdi mdi-chevron-down ms-auto' />
          </button>

          <div
            id={`mem-collapse-${parent.id}`}
            className={`collapse ${activeId === parent.id ? 'show' : ''}`}
          >
            <ul className='list-unstyled mt-2 ps-4'>
              {parent.children?.length ? (
                parent.children.map((child, idx) => (
                  <li
                    key={`${parent.id}-${idx}`} // unique keys per parent-child
                    className='d-flex align-items-center py-1'
                    onClick={() => onItemSelect && onItemSelect(child)}
                    style={{ cursor: 'pointer' }}
                  >
                    <i
                      className={`${child.icon} font-size-16 text-secondary me-2`}
                    />
                    <span className='flex-grow-1 font-size-12'>
                      {child.label}
                    </span>
                    {(child.count || 0) > 0 && (
                      <span className='badge bg-primary fw-bold'>
                        {child.count}
                      </span>
                    )}
                  </li>
                ))
              ) : (
                <li className='text-muted small ps-1'>No items</li>
              )}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MemorialMenu;
